import { LoaderCircle } from "lucide-react";
import { cx } from "../lib/cx";

export function Spinner({ className, ...props }: { className?: string }) {
  return (
    <LoaderCircle
      className={cx("animate-spin text-muted-foreground", className)}
      {...props}
    />
  );
}
